import React from "react";
import { useVideoId } from "./hooks/useVideoId";
import KycElectronicID from "../../kyc/KycAutomatic/shared/steps/KycElectronicId";

export default function VideoId() {
  const { electronicIdSubmitted, onSubmitKycElectronicId } = useVideoId();

  return (
    <>
      {!electronicIdSubmitted && (
        <KycElectronicID
          onSubmitForm={onSubmitKycElectronicId}
          disableKycManual={true}
          allowInternationalBorrower={false}
        />
      )}
    </>
  );
}
